module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'carouselScreen': (_vm.isMobileDevice && _vm.isLandscape)
    },
    on: {
      "touchmove": _vm.stopScroll
    }
  }, [_c('div', {
    ref: "carouselContainer",
    staticClass: "carousel",
    style: (_vm.containerStyle),
    on: {
      "touchmove": _vm.moveTouch,
      "touchstart": _vm.startTouch,
      "touchend": _vm.moveStop,
      "touchleave": _vm.mouseLeave,
      "mousedown": _vm.moveStart,
      "mouseup": _vm.moveStop,
      "mouseout": _vm.mouseLeave,
      "mouseover": _vm.mouseOver
    }
  }, [_c('div', {
    ref: "carouselSlider",
    staticClass: "image-container",
    style: (_vm.sliderStyle)
  }, _vm._l((_vm.slideList), function(slide, index) {
    return (_vm.checkProgressiveReveal(index)) ? _c('div', {
      key: index,
      staticClass: "images",
      style: (_vm.imageStyle(slide))
    }) : _vm._e()
  })), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', [(_vm.showFullscreen && _vm.isFullScreenSupported) ? _c('div', {
    staticClass: "fullscreenButton",
    on: {
      "click": _vm.switchFullScreen
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/fullscreen.svg")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isLeftArrowVisible) ? _c('div', {
    staticClass: "arrowButtonLeft",
    on: {
      "click": function($event) {
        _vm.changeSlide(_vm.currentSlide - 1);
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/arrow.svg")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isRightArrowVisible) ? _c('div', {
    staticClass: "arrowButtonRight",
    on: {
      "click": function($event) {
        _vm.changeSlide(_vm.currentSlide + 1);
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/arrow.svg")
    }
  })]) : _vm._e()])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cd90370","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Carousel.vue
// module id = 481
// module chunks = 0